// TODO: Refactor this component, use <RelevantSessionActionButtons/>

import { StopOutlined } from '@ant-design/icons';
import { ReactComponent as SessionDetailsIcon } from '@assets/icons/V4/info-icon.svg';
import { ReactComponent as CameraIcon } from '@assets/icons/video-icons/camera-icon.svg';
import IconButton from '@components/V4/IconButton';
import { Feedback } from '@modules/Mentor/components/FeedbackModal/FeedbackModal';
import { Meeting } from '@shared/common';
import { Tooltip } from 'antd';
import { useAnalytics } from 'apps/agora/src/contexts/AnalyticsContext';
import { ANALYTICS_EVENT_NAMES } from 'apps/agora/src/utils/constants';
import moment from 'moment';
import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Link, useHistory } from 'react-router-dom';
import { COLORS } from '../../../v3/global';
import GiveFeedbackButtonMentor from '../../../views/UserView/Home/Common/Buttons/GiveFeedbackButtonMentor';
import GiveFeedbackButtonStudent from '../../../views/UserView/Home/Common/Buttons/GiveFeedbackButtonStudent';
import EnrollmentIcon from '../EnrollmentIcon';
import './next-meeting.styles.scss';
import '../../../views/UserView/Home/Common/Buttons/meeting-card-buttons.styles.scss';

export type NextMeetingDateToShow = 'scheduledDate' | 'endDate';
interface MeetingWithSessionId extends Meeting {
  sessionId: string;
}

interface Props {
  meeting: MeetingWithSessionId;
  otherName: string;
  meetingNeedingFeedback?: boolean;
  meetingNeedingFeedbackStudent?: boolean;
  isMentor?: boolean;
  isPreview?: boolean;
  abbreviationPreview?: string;
  hideJoinBtn?: boolean;
  isPastMeeting?: boolean;
  isUserProfileView?: boolean;
  dateToShow?: NextMeetingDateToShow;
  setShowFeedbackModal?: React.Dispatch<React.SetStateAction<boolean>>;
  setFeedbackModalData?: React.Dispatch<
    React.SetStateAction<{
      id: string;
      feedback: Feedback;
      title: string;
    }>
  >;
}

const NextMeeting: React.FC<Props> = ({
  meeting,
  otherName,
  children,
  meetingNeedingFeedback,
  meetingNeedingFeedbackStudent,
  isMentor = true,
  isPreview,
  abbreviationPreview,
  hideJoinBtn = false,
  isPastMeeting = false,
  isUserProfileView = false,
  dateToShow = 'endDate',
  setShowFeedbackModal,
  setFeedbackModalData,
}) => {
  const tooltipRef = useRef<HTMLDivElement | null>(null);
  const divParentRef = useRef<HTMLDivElement | null>(null);
  const [divParentWidth, setDivParentWidth] = useState(0);

  const { name } = meeting;
  const [isClicked, setIsClicked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const history = useHistory();

  const { trackEvent } = useAnalytics();

  const handleArrowClick = () => {
    setIsClicked(!isClicked);
  };

  const formatMeetingTime = (scheduledDate: string, endTime?: string) => {
    const dateFormat = 'DD MMM HH:mm';
    if (dateToShow === 'endDate') {
      return endTime
        ? moment(endTime).format(dateFormat)
        : moment(scheduledDate).format(dateFormat);
    } else {
      return moment(scheduledDate).format(dateFormat);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (divParentRef.current) {
        const width = divParentRef.current.offsetWidth;
        setDivParentWidth(width);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      const tooltipNode = ReactDOM.findDOMNode(tooltipRef.current);
      const isClickedOutside = tooltipNode && !tooltipNode.contains(target);
      const isClickedInsideContent = (target as Element)?.closest('.ant-tooltip-inner');

      if (isClickedOutside) {
        if (isClickedInsideContent) {
          setTimeout(() => setIsClicked(false), 100);
        } else {
          setIsClicked(false);
        }
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isClicked]);

  const content = () => {
    if (isMentor && meeting?.enrollment?.user?.isDeactivated) {
      return (
        <div
          style={{
            marginTop: isMentor && meeting?.enrollment?.user?.isDeactivated ? -20 : '',
          }}
          className="next-meeting-content-container"
        >
          <div>
            {isMentor && meeting?.enrollment?.user?.isDeactivated && (
              <StopOutlined
                style={{
                  color: COLORS.ERROR,
                }}
                className="next-meeting-stop-icon"
              />
            )}
            <EnrollmentIcon
              abbreviation={abbreviationPreview ?? meeting?.enrollment?.abbreviation}
              enrollmentColor={
                meeting?.enrollment?.color
                  ? meeting?.enrollment?.color
                  : meeting?.enrollment?.user?.isDeactivated
                  ? COLORS.DARK_GREY3
                  : name.toLowerCase().includes('coach') || name.toLowerCase().includes('training')
                  ? COLORS.PRIMARY
                  : name.toLowerCase().includes('academic')
                  ? COLORS.PURPLE
                  : COLORS.GOLD
              }
              enrollmentTitle={
                abbreviationPreview
                  ? abbreviationPreview
                  : meeting?.enrollment?.abbreviation
                  ? meeting?.enrollment?.abbreviation
                  : meeting?.enrollment?.course?.title
              }
              size={48}
              fontSize="16px"
              courseId={meeting?.enrollment?.course?._id}
              margin={'16px'}
            />
          </div>
          <div
            style={{
              marginTop: isMentor && meeting?.enrollment?.user?.isDeactivated ? 20 : '',
            }}
            className="next-meeting-title-container"
          >
            <div
              style={{
                width:
                  meetingNeedingFeedback || meetingNeedingFeedbackStudent
                    ? 'calc(100% - 16px)'
                    : '100%',
              }}
              className="next-meeting-title"
            >
              <span
                onClick={() =>
                  !isPreview && !isUserProfileView && isMentor
                    ? history.push(`/student-profile/${meeting?.enrollment?.user?._id}`)
                    : undefined
                }
                style={{
                  cursor: isMentor && !isUserProfileView ? 'pointer' : 'default',
                  fontSize: '13px',
                  textDecoration:
                    isMentor && !isUserProfileView && meeting?.enrollment?.user?.isDeactivated
                      ? 'line-through'
                      : 'none',
                  color:
                    isMentor && !isUserProfileView && isHovered
                      ? COLORS.PRIMARY
                      : COLORS.TEXT_PRIMARY,
                }}
                onMouseEnter={() => {
                  setIsHovered(true);
                }}
                onMouseLeave={() => setIsHovered(false)}
              >
                {otherName}
              </span>
              <span style={{ fontSize: '13px', color: COLORS.TEXT_PRIMARY }}>
                {' '}
                - {meeting?.currentSession ?? '-'} of {meeting?.totalSessions ?? '-'}
              </span>
            </div>

            <div style={{ width: divParentWidth }}>
              <div
                style={{
                  color: COLORS.TEXT_SECONDARY,
                  width:
                    meetingNeedingFeedback || meetingNeedingFeedbackStudent
                      ? 'calc(100% - 104px - 94px - 16px)'
                      : 'calc(100% - 104px - 94px)',
                }}
                className="next-meeting-date"
              >
                <span
                  style={{
                    fontSize: '13px',
                    textDecoration:
                      isMentor && meeting?.enrollment?.user?.isDeactivated
                        ? 'line-through'
                        : 'none',
                  }}
                >
                  {formatMeetingTime(meeting?.scheduledDate, meeting?.endTime)},{' '}
                  {meeting?.enrollment?.course?.title}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            color: 'inherit',
            display: 'flex',
            maxWidth: 'calc(100% - 104px)',
            marginTop: isMentor && meeting?.enrollment?.user?.isDeactivated ? -20 : '',
          }}
        >
          <div>
            {isMentor && meeting?.enrollment?.user?.isDeactivated && (
              <StopOutlined
                style={{
                  color: COLORS.ERROR,
                }}
                className="next-meeting-stop-icon"
              />
            )}
            <EnrollmentIcon
              abbreviation={abbreviationPreview ?? meeting?.enrollment?.abbreviation}
              enrollmentColor={
                meeting?.enrollment?.color
                  ? meeting?.enrollment?.color
                  : meeting?.enrollment?.user?.isDeactivated
                  ? COLORS.DARK_GREY3
                  : name.toLowerCase().includes('coach') || name.toLowerCase().includes('training')
                  ? COLORS.PRIMARY
                  : name.toLowerCase().includes('academic')
                  ? COLORS.PURPLE
                  : COLORS.GOLD
              }
              enrollmentTitle={
                abbreviationPreview
                  ? abbreviationPreview
                  : meeting?.enrollment?.abbreviation
                  ? meeting?.enrollment?.abbreviation
                  : meeting?.enrollment?.course?.title
              }
              size={48}
              fontSize="16px"
              courseId={meeting?.enrollment?.course?._id}
              margin={'16px'}
            />
          </div>

          <div
            style={{
              marginTop: isMentor && meeting?.enrollment?.user?.isDeactivated ? 20 : '',
            }}
            className="next-meeting-title-container"
          >
            <div
              style={{
                width:
                  meetingNeedingFeedback || meetingNeedingFeedbackStudent
                    ? 'calc(100% - 16px)'
                    : '100%',
              }}
              className="next-meeting-title"
            >
              <span
                onClick={() =>
                  !isPreview && isMentor
                    ? history.push(`/student-profile/${meeting?.enrollment?.user?._id}`)
                    : undefined
                }
                style={{
                  cursor: isMentor && !isUserProfileView ? 'pointer' : 'default',
                  textDecoration:
                    isMentor && !isUserProfileView && meeting?.enrollment?.user?.isDeactivated
                      ? 'line-through'
                      : isMentor && !isUserProfileView && isHovered
                      ? 'underline'
                      : 'none',
                  fontSize: '13px',
                  color:
                    isMentor && !isUserProfileView && isHovered
                      ? COLORS.PRIMARY
                      : COLORS.TEXT_PRIMARY,
                }}
                onMouseEnter={() => {
                  setIsHovered(true);
                }}
                onMouseLeave={() => setIsHovered(false)}
              >
                {otherName}
              </span>
              <span style={{ fontSize: '13px', color: COLORS.TEXT_PRIMARY }}>
                {' '}
                - {meeting?.currentSession ?? '-'} of {meeting?.totalSessions ?? '-'}
              </span>
            </div>

            <div style={{ width: divParentWidth }}>
              <div
                style={{
                  color: COLORS.TEXT_SECONDARY,
                  width:
                    meetingNeedingFeedback || meetingNeedingFeedbackStudent
                      ? 'calc(100% - 104px - 94px - 16px)'
                      : 'calc(100% - 104px - 94px)',
                }}
                className="next-meeting-date"
              >
                <span
                  style={{
                    fontSize: '13px',
                    textDecoration:
                      isMentor && meeting?.enrollment?.user?.isDeactivated
                        ? 'line-through'
                        : 'none',
                  }}
                >
                  {formatMeetingTime(meeting?.scheduledDate, meeting?.endTime)},{' '}
                  {meeting?.enrollment?.course?.title}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <Tooltip
      zIndex={1}
      color="transparent"
      placement="topLeft"
      trigger="hover"
      title={
        isMentor && meeting?.enrollment?.user?.isDeactivated ? (
          <div
            style={{
              padding: '12px 16px',
              color: COLORS.TEXT_PRIMARY,
            }}
            className="tooltip-container"
          >
            User has been deactivated. For any questions please contact our support team.
          </div>
        ) : (
          <div style={{ padding: '0px' }}></div>
        )
      }
    >
      <div ref={divParentRef} className="next-meeting-card-container bg-surfaceHover">
        {content()}

        <div className="next-meeting-card-content-container">
          {isPastMeeting && (
            <Tooltip
              zIndex={1}
              color="transparent"
              placement="topRight"
              trigger="hover"
              title={
                <div className="feedback-button-tooltip">
                  <span className="text-customGrey">Session Details</span>
                </div>
              }
            >
              <Link
                to={`/session-details/${meeting.sessionId}`}
                onClick={() => trackEvent(ANALYTICS_EVENT_NAMES.SESSION_DETAILS_GOTO_BUTTON_CLICK)}
              >
                <IconButton variant="ghost" icon={<SessionDetailsIcon />} />
              </Link>
            </Tooltip>
          )}
          {/*JOIN MEETING ICON BUTTON*/}
          {!(isMentor && meeting?.enrollment?.user?.isDeactivated) && !hideJoinBtn && (
            <div className="next-meeting-button-tooltip-container flex items-center">
              <Tooltip
                zIndex={1}
                color="transparent"
                placement="topRight"
                trigger="hover"
                title={
                  <div className="feedback-button-tooltip">
                    <span
                      style={{
                        color: COLORS.TEXT_SECONDARY,
                      }}
                    >
                      Join Meeting
                    </span>
                  </div>
                }
              >
                {isPreview ? (
                  <IconButton icon={<CameraIcon className="w-4" />} />
                ) : (
                  <Link rel="noopener noreferrer" to={`/video-meeting/${meeting._id}`}>
                    <IconButton icon={<CameraIcon className="w-4" />} />
                  </Link>
                )}
              </Tooltip>
            </div>
          )}

          {meetingNeedingFeedback && setShowFeedbackModal && setFeedbackModalData && (
            <div className="next-meeting-button-tooltip-container flex gap-2 m-0">
              <GiveFeedbackButtonMentor
                setShowModal={setShowFeedbackModal}
                setFeedbackModalData={setFeedbackModalData}
                meeting={meeting}
              />
              <Tooltip
                zIndex={1}
                color="transparent"
                placement="topRight"
                trigger="hover"
                title={
                  <div className="feedback-button-tooltip">
                    <span className="text-customGrey">Session Details</span>
                  </div>
                }
              >
                <Link
                  to={`/session-details/${meeting.sessionId}`}
                  onClick={() =>
                    trackEvent(ANALYTICS_EVENT_NAMES.SESSION_DETAILS_GOTO_BUTTON_CLICK)
                  }
                >
                  <IconButton variant="ghost" icon={<SessionDetailsIcon />} />
                </Link>
              </Tooltip>
            </div>
          )}

          {meetingNeedingFeedbackStudent && (
            <div className="next-meeting-button-tooltip-container flex gap-2 m-0">
              <Tooltip
                zIndex={1}
                color="transparent"
                placement="bottom"
                trigger="hover"
                title={
                  <div
                    style={{
                      padding: '24px',
                      color: COLORS.TEXT_PRIMARY,
                    }}
                    className="tooltip-container"
                  />
                }
              >
                <GiveFeedbackButtonStudent meeting={meeting} />
              </Tooltip>
              <Tooltip
                zIndex={1}
                color="transparent"
                placement="topRight"
                trigger="hover"
                title={
                  <div className="feedback-button-tooltip">
                    <span className="text-customGrey">Session Details</span>
                  </div>
                }
              >
                <Link
                  to={`/session-details/${meeting.sessionId}`}
                  onClick={() =>
                    trackEvent(ANALYTICS_EVENT_NAMES.SESSION_DETAILS_GOTO_BUTTON_CLICK)
                  }
                >
                  <IconButton variant="ghost" icon={<SessionDetailsIcon />} />
                </Link>
              </Tooltip>
            </div>
          )}

          {!!children && (
            <Tooltip
              ref={tooltipRef}
              zIndex={9999}
              color="transparent"
              placement="bottom"
              trigger="click"
              visible={isPreview ? false : isClicked}
              title={
                <div
                  style={{
                    color: COLORS.TEXT_PRIMARY,
                    backgroundColor: COLORS.COMPONENT_BACKGROUND,
                    minWidth: '208px',
                  }}
                  className="tooltip-container next-meeting-card-tooltip-menu-container"
                >
                  {children}
                </div>
              }
            >
              <div onClick={handleArrowClick} className="next-meeting-card-more-button-container">
                {isClicked ? (
                  <span className="button-icon-container">
                    <div className="meeting-card-more-icon-clicked" />
                  </span>
                ) : (
                  <span className="button-icon-container">
                    <div className="meeting-card-more-icon" />
                  </span>
                )}
              </div>
            </Tooltip>
          )}
        </div>
      </div>
    </Tooltip>
  );
};

export default NextMeeting;
